/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { useEffect } from 'react'
import { iIndicador, iMesPeriodo } from '../../../gestao'
import { FormatarNumero } from '../../../../../Utils/Helper'

interface BarChartProps {
  id: string
  // valorMaximo: number
  data: iMesPeriodo[]
  indicador: iIndicador
}

export const IndicadorChart: React.FC<BarChartProps> = ({ id, data, indicador }) => {
  function GetAcumulado(index: number): number {
    let response = 0
    if (indicador.tipoMeta === 5) {
      response = data[index].real ?? 0
    } else {
      for (let i = 0; i < index + 1; i++) {
        response += data[i].real ?? 0
      }
    }

    return response
  }
  const mesesAbreviados = [
    'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
  ]
  function GerarGrafico(): void {
    const options = {
      chart: {
        height: 350,
        type: 'line',
        stacked: false,
        zoom: {
          enabled: false
        }
      },
      markers: {
        size: 6
      },
      dataLabels: {
        enabled: false
      },
      colors: ['#27AE60', '#F2994A'],
      series: [
        {
          name: 'Valor Acumulado',
          data: data.map((e, i) => GetAcumulado(i))
        },
        {
          name: 'Valor Previsto',
          data: data.map((e) => e.previsto)
        }
      ],
      stroke: {
        width: [4, 4]
      },
      plotOptions: {
        bar: {
          columnWidth: '20%'
        }
      },
      // yaxis: {
      //   max: valorMaximo
      // },
      xaxis: {
        categories: data.map(e => e.numeroMes).map(e => mesesAbreviados[e - 1])
      },
      yaxis: {
        labels: {
          formatter: function(value: any) {
            return indicador.tipoMeta === 0 ? `${indicador.medidaMeta ?? ''}${FormatarNumero(value, indicador)}` : `${FormatarNumero(value, indicador)}${indicador.medidaMeta ?? ''}`
          }
        }
      },
      tooltip: {
        shared: false,
        intersect: true,
        x: {
          show: false
        },
        y: {
          show: true,
          formatter: function(value: any) {
            return indicador.tipoMeta === 0 ? `${indicador.medidaMeta ?? ''}${FormatarNumero(value, indicador)}` : `${FormatarNumero(value, indicador)}${indicador.medidaMeta ?? ''}`
          }
        }
      },
      legend: {
        horizontalAlign: 'left',
        offsetX: 40
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
      <Flex id={`chart-${id}`} />
  )
}
